import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { LoginService } from '../login/login.service';

@Injectable({
  providedIn: 'root'
})
export class SurtimientoService {
  private urlApi: string = environment.apiUrl;
  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  getSurtimientos(empresaId: number, fechaInicio: any, fechaFin: any, almacenId: string) {
    let datos = {
      "option": "surtimientos",
      "empresaId": 5,
      "almacenId": almacenId,
      "fechaDesde": fechaInicio,
      "fechaHasta": fechaFin,
    }

    return this.http.post(this.urlApi + 'Servicios-web/Admin/SurtimientoMercancia.php', datos)
      .pipe(catchError(this.errorHandler),
        map((res: any) => {
          return res;
        }));
  }

  getDatalleSurtimiento(empresaId: number, almacenId: string, surtimientoId: string, tipoOrden: string) {
    let datos = {
      "option": "surtimientoSel",
      "empresaId": 5,
      "almacenId": almacenId,
      "surtimiento": surtimientoId,
      "tipoOrden": tipoOrden
    }
    return this.http.post(this.urlApi + 'Servicios-web/Admin/SurtimientoMercancia.php', datos)
      .pipe(catchError(this.errorHandler),
        map((res: any) => {
          return res;
        }));
  }

  postFirmaSurtimiento(empresaId: number, almacenId: string, surtimientoId: string, firma: Blob) {
    let formData = new FormData();
    formData.append('option', 'surtimientoIns');
    formData.append('empresaId', empresaId.toString());
    formData.append('almacenId', almacenId);
    formData.append('surtimiento', surtimientoId);
    formData.append('firma', firma);
    formData.append('quien', this.loginService.getCorreoUsuario());

    return this.http.post(this.urlApi + 'Servicios-web/Admin/SurtimientoMercancia.php', formData)
      .pipe(catchError(this.errorHandler),
        map((res: any) => {
          return res;
        }));
  }

  private errorHandler = (error: HttpErrorResponse | any) => {
    Swal.fire({
      type: 'error',
      title: 'Error - Surtimiento',
      text:
        'Lo sentimos, Ocurrio un error de comunicación, Favor de contactarse con el administrador del sitio Incidencias@integradora.net' +
        error.message,
    });
    return throwError(error);
  };
}
